export function applicationIsLoading(bool) {
  return {
    type: "APPLICATION_IS_LOADING",
    isLoading: bool
  }
}